// extracted by mini-css-extract-plugin
module.exports =  {"root":"M2b_iCjQliDfyqVbnAtl","flex":"piohCa2p4ghV0IH7vDVp"};